<form (ngSubmit)="onFormSubmit(filterForm)" id="filterForm" #filterForm="ngForm">
  <div class="row search-filter-row" [ngClass]="{ expanded: expanded }">
    <div class="col-12">
      <div class="row search-filter-row-primary">
        <div class="col-8">
          <div class="row">
            <div class="col-11">
              <div class="ui-inputgroup ey-float-label row">
                <input
                  type="text"
                  name="searchStudies"
                  class="form-control search-box ey-field"
                  appLabelFloat
                  [(ngModel)]="searchText"
                  aria-label="Search Studies"
                  (keydown.enter)="onEnterKey()"
                />
                <label>Search studies</label>
              </div>
            </div>
            <div class="col-1 align-self-center">
              <span class="ui-inputgroup-addon search-icon">
                <a href (click)="$event.preventDefault(); onSearchClick()">
                  <i class="material-icons search-icon">search</i>
                </a>
              </span>
            </div>
          </div>
        </div>
        <div id="sort-container" class="col-3 align-self-center">
          <div class="row">
            <div id="sort-prompt" class="col-2 align-self-center">Sort<br />by</div>
            <div id="sort-select-container" class="col-10">
              <select id="sort-select" class="form-control form-select" name="sortSelect" [(ngModel)]="selectedSort" (change)="onSortChange()" aria-label="Sort by">
                <option *ngFor="let sortOption of sortOptions" value="{{ sortOption.value }}">
                  {{ sortOption.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div id="expand-icon-container" class="col-1 align-self-center">
          <a href (click)="$event.preventDefault(); onClickExpand()" class="filter-list-expand" aria-label="Filter">
            <span><i id="expand-icon" class="material-icons">filter_list</i></span>
          </a>
        </div>
      </div>
      <div class="row search-filter-row-secondary">
        <div class="col-12">
          <div class="form-group">
            <div class="row">
              <div class="col-12">Search and Filter</div>
            </div>
            <div id="criteria-row" class="row" *ngFor="let filterCriteria of filterCriterias">
              <div class="col-4">
                <span class="ey-float-label">
                  <select
                    class="form-control form-select"
                    #filterEntity="ngModel"
                    name="{{ getUniqueName('filterEntity', filterCriteria) }}"
                    [(ngModel)]="filterCriteria.entity"
                    appLabelFloat
                    required
                    aria-label="Entity Name"
                  >
                    <option *ngFor="let entity of filterEntityOptions" value="{{ entity.value }}">
                      {{ entity.label }}
                    </option>
                  </select>
                  <label>Entity Name</label>
                </span>
                <span class="help-block">
                  <span *ngIf="showValidationMessage(filterEntity) && filterEntity.errors.required"> Please select an Entity </span>
                </span>
              </div>
              <div class="col-4">
                <span class="ey-float-label">
                  <select
                    class="form-control form-select"
                    #filterOpcode="ngModel"
                    name="{{ getUniqueName('filterOpcode', filterCriteria) }}"
                    [(ngModel)]="filterCriteria.opcode"
                    appLabelFloat
                    required
                    aria-label="Option"
                  >
                    <option *ngFor="let operator of filterOperationOptions" value="{{ operator.value }}">
                      {{ operator.label }}
                    </option>
                  </select>
                </span>
                <span class="help-block">
                  <span *ngIf="showValidationMessage(filterOpcode) && filterOpcode.errors.required"> Please select a Option </span>
                </span>
              </div>
              <div class="col-3">
                <span class="ey-float-label row">
                  <input
                    class="form-control filter-value"
                    #filterValue="ngModel"
                    name="{{ getUniqueName('filterValue', filterCriteria) }}"
                    [(ngModel)]="filterCriteria.value"
                    type="text"
                    appLabelFloat
                    required
                    aria-label="Filter value"
                  />
                  <label>Enter Value</label>
                </span>
                <span class="help-block">
                  <span *ngIf="showValidationMessage(filterValue) && filterValue.errors.required"> Please enter a value </span>
                </span>
              </div>
              <div class="col-1 align-self-center">
                <a
                  href
                  id="delete-filter-btn"
                  class="col-2"
                  *ngIf="filterCriterias.length > 1"
                  aria-label="Delete"
                  (click)="$event.preventDefault(); onRemoveFilterClick(filterCriteria)"
                >
                  <span><i class="material-icons delete-icon">delete</i></span>
                </a>
                <span class="help-block"></span>
              </div>
            </div>
            <div id="add-filter-row" class="row">
              <div class="col-12">
                <a href id="add-filter-btn" aria-label="Add a Filter" (click)="$event.preventDefault(); onAddFilterClick()">
                  <span><i id="add-filter-icon" class="material-icons">add_circle</i>&nbsp;Add a Filter</span>
                </a>
              </div>
            </div>
            <div class="row btn-row">
              <div class="col-12">
                <button type="button" class="btn btn-default" (click)="onResetFilterClick()">Reset</button>
                <button type="submit" class="btn btn-primary">Apply Filter</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
